// extracted by mini-css-extract-plugin
export default {"rider":"Rider_rider__DKuvX","riderGrid":"Rider_riderGrid__7en+3","riderPitch":"Rider_riderPitch__FFhOx"};